import { render, staticRenderFns } from "./AddLogShippingComponent.vue?vue&type=template&id=4127c610&"
import script from "./AddLogShippingComponent.vue?vue&type=script&lang=js&"
export * from "./AddLogShippingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports